const config = {
  path: {
    images: '/images'
  },
  images: '/images/'
};

export default config;
